import React, { useState } from 'react';
import { Link } from "gatsby"
import './Header.css';
import imgLogo from '../images/logo-amt.jpg';
import LanguageSelector from './languageSelector';
import { MdMenu } from "react-icons/md";
import { useTranslation } from 'react-i18next';

const Header = () => {
    const { t } = useTranslation();
    
    const url = typeof window !== 'undefined' ? window.location.pathname : '';

    const [navbarVisibility, setNavbarvisibility] = useState(false);

    function toggleNavbar() {
        const navbar = document.getElementById('header__nav');
        const burguer = document.getElementById('nav__burguer');
        navbar.classList.toggle('header__nav--visible');
        burguer.classList.toggle('nav__burguer--visible');
        
        setNavbarvisibility(!navbarVisibility);
    }

    function changeLanguageHandler() {
        if (navbarVisibility) {
            toggleNavbar();
        }
    }

    const NavLink = ({ ruta, texto }) => (
        <Link to={ruta}>
            <li className={`nav__link ${url.includes(`${ruta}`) ? 'nav__link--active' : ''}`}>
                {texto}
            </li>  
        </Link>
    )


    return(
        <header className="header">
            { navbarVisibility ? 
                <div className="nav__background" id="nav__background" onClick={toggleNavbar}></div> 
                : null
            }
            <Link to="/">
                <div className="header__logo" id="header-logo">
                    
                        <img src={imgLogo} alt="Logo" className="logo__img" />
                        <span className="logo__text">AMT Solar</span>
                    
                </div>
            </Link>
            <nav id="header__nav" className="header__nav">
                <ul>
                    <NavLink ruta="/parks" texto={t('NAV_PARQUES')} />

                    <NavLink ruta="/investigation" texto={t('NAV_INVESTIGACION')} />

                    <NavLink ruta="/integration" texto={t('NAV_INTEGRACION')} />
                    
                    <NavLink ruta="/recharges" texto={t('NAV_RECARGAS')} />

                    <NavLink ruta="/cooling" texto={t('NAV_SOLARCOOLING')} />

                    <NavLink ruta="/hydrogen" texto={t('NAV_HIDROGENO')} />

                    <NavLink ruta="/contact" texto={t('NAV_CONTACTO')} />

                    <li><LanguageSelector location="HEADER" changeLanguageHandler={changeLanguageHandler} /></li>
                </ul>
            </nav>
            <span id="nav__burguer" className="nav__burguer" onClick={toggleNavbar}><MdMenu /></span>
        </header>
    )
}


export default Header
